import { configureStore } from "@reduxjs/toolkit";
import combinedReducer from "./reducers";
const store = configureStore({
  reducer: combinedReducer
});
var stdin_default = store;
export {
  stdin_default as default
};
